import { CanMatchFn } from '@angular/router';
import { CITIES, FEATURES } from './seo-config.data';

/*
 * The SEO aliases are param routes narrowed by these guards rather than
 * `UrlMatcher`s, because Angular's prerenderer cannot enumerate a matcher
 * route (angular-cli#29384). A rejected guard falls through to the next route,
 * exactly as a matcher returning null did.
 *
 * `segments` is every remaining segment, not only the ones the route's path
 * consumes, so the length checks keep `/new-york/crime-rate/extra` out.
 */

export const cityFeatureCanMatch: CanMatchFn = (_route, segments) => {
  if (segments.length !== 2) return false;
  const [sCity, sFeat] = segments;
  const feature = FEATURES[sFeat.path];
  return !!CITIES[sCity.path] && !!feature && !feature.singlePage;
};

export const featureOnlyCanMatch: CanMatchFn = (_route, segments) =>
  segments.length === 1 && !!FEATURES[segments[0].path];
